<div class="language">
  <a class="language__link" (click)="changeUserLanguage('pl'); translate.use('pl')">
    @if (mode === 'light') {
      <app-icon name="pl" size="40"></app-icon>
    }
    @if (mode === 'dark') {
      <app-icon name="pl-gr" size="40"></app-icon>
    }
  </a>
  <a class="language__link" (click)="changeUserLanguage('ru'); translate.use('ru')">
    @if (mode === 'light') {
      <app-icon name="ru" size="40"></app-icon>
    }
    @if (mode === 'dark') {
      <app-icon name="ru-gr" size="40"></app-icon>
    }
  </a>
  <a class="language__link" (click)="changeUserLanguage('en'); translate.use('en')">
    @if (mode === 'light') {
      <app-icon name="en" size="40"></app-icon>
    }
    @if (mode === 'dark') {
      <app-icon name="en-gr" size="40"></app-icon>
    }
  </a>
  <a class="language__link" (click)="changeUserLanguage('de'); translate.use('de')">
    @if (mode === 'light') {
      <app-icon name="de" size="40"></app-icon>
    }
    @if (mode === 'dark') {
      <app-icon name="de-gr" size="40"></app-icon>
    }
  </a>
  <a class="language__link" (click)="changeUserLanguage('uk'); translate.use('uk')">
    @if (mode === 'light') {
      <app-icon name="uk" size="40"></app-icon>
    }
    @if (mode === 'dark') {
      <app-icon name="uk-gr" size="40"></app-icon>
    }
  </a>
</div>
